import { render, staticRenderFns } from "./inviteDetail.vue?vue&type=template&id=6db78b7d&scoped=true&"
import script from "./inviteDetail.vue?vue&type=script&lang=js&"
export * from "./inviteDetail.vue?vue&type=script&lang=js&"
import style0 from "./inviteDetail.vue?vue&type=style&index=0&id=6db78b7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db78b7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db78b7d')) {
      api.createRecord('6db78b7d', component.options)
    } else {
      api.reload('6db78b7d', component.options)
    }
    module.hot.accept("./inviteDetail.vue?vue&type=template&id=6db78b7d&scoped=true&", function () {
      api.rerender('6db78b7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/invite/inviteDetail.vue"
export default component.exports